module.exports = __webpack_public_path__ + "assets/c17d246d7bebb604966a6e60aa1a78e3.mp3";